module.exports = __webpack_public_path__ + "img/Unicom-6.ab31c77c.svg";